export const mandateDetails = {
    mandatePurpose: [
        {
            "label" : "Low value mandate",
            "value" : "S001"
        }, 
        {
            "label" : "B2B Corporate",
            "value" : "C001"
        }, 
        {
            "label" : "Bill Payment Credit card",
            "value" : "B001"
        }, 
        {
            "label" : "Destination Bank Mandate",
            "value" : "D001"
        }, 
        {
            "label" : "Education fees",
            "value" : "E001"
        }, 
        {
            "label" : "Insurance Premium",
            "value" : "I001"
        }, 
        {
            "label" : "Insurance other payment",
            "value" : "I002"
        }, 
        {
            "label" : "Loan amount security",
            "value" : "L002"
        }, 
        {
            "label" : "Loan installment payment",
            "value" : "L001"
        }, 
        {
            "label" : "Mutual Fund Payment",
            "value" : "M001"
        }, 
        {
            "label" : "Subscription Fees",
            "value" : "F001"
        }, 
        {
            "label" : "TReDS",
            "value" : "T002"
        }, 
        {
            "label" : "Tax  Payment",
            "value" : "T001"
        }, 
        {
            "label" : "Utility Bill Payment Electricity",
            "value" : "U001"
        }, 
        {
            "label" : "Utility Bill payment Gas Supply Cos",
            "value" : "U003"
        }, 
        {
            "label" : "Utility Bill payment mobile telephone broadband",
            "value" : "U005"
        }, 
        {
            "label" : "Utility Bill payment water",
            "value" : "U006"
        }, 
        {
            "label" : "Others",
            "value" : "U099"
        }
    ],
    mandateVariant: [
        {
            "label" : "API-eMandate (ONMAGS)",
            "value" : "netBanking"
        }, 
        {
            "label" : "Physical NACH",
            "value" : "physicalNach"
        }, 
        {
            "label" : "Aadhaar based eMandate",
            "value" : "eSign"
        }
    ],
    frequency: [
        {
            "label" : "Adhoc",
            "value" : "ADHO"
        }, 
        {
            "label" : "Yearly",
            "value" : "YEAR"
        }, 
        {
            "label" : "Weekly",
            "value" : "WEEK"
        }, 
        {
            "label" : "Quarterly",
            "value" : "QURT"
        }, 
        {
            "label" : "Monthly",
            "value" : "MNTH"
        }
    ]
}